import { ProductStatus } from '@parallel-fluidics/shared/models/products';
import { doc } from 'firebase/firestore';

/**
 * Called inside an existing Firestore transaction.
 * Retires the currently active version (if different) and updates the product's activeVersionId.
 */
export default function promoteActiveVersion(transaction, {
  db,
  productDocId,
  versionId,
  currentActiveId,
  serverTimestamp,
}) {
  if (currentActiveId && currentActiveId !== versionId) {
    transaction.set(
      doc(db, 'products', productDocId, 'versions', currentActiveId),
      { status: ProductStatus.RETIRED, retiredAt: serverTimestamp() },
      { merge: true },
    );
  }

  transaction.set(
    doc(db, 'products', productDocId),
    {
      activeVersionId: versionId,
      updatedAt: serverTimestamp(),
    },
    { merge: true },
  );
}
